export const textStyles = {
  heading60: {
    fontSize: ["42px", "52px", "60px"],
    fontWeight: 800,
    lineHeight: 1.1,
  },
  heading36: {
    fontSize: ["30px", "34px", "36px"],
    fontWeight: 800,
    lineHeight: 1.1,
  },
  heading24: {
    fontSize: ["16px", "20px", "24px"],
    fontWeight: 800,
    lineHeight: 1.1,
  },
  heading20: {
    fontSize: ["18px", "18px", "20px"],
    fontWeight: 400,
    lineHeight: 1.1,
  },
  heading16: {
    fontSize: ["14px", "14px", "16px"],
    fontWeight: 700,
    lineHeight: 1.1,
  },
  base: {
    500: {
      fontSize: ["16px", "20px", "24px"],
      fontWeight: 600,
      lineHeight: 1,
    },
    400: {
      fontSize: ["18px", "18px", "20px"],
      fontWeight: 600,
      lineHeight: 1,
    },
    300: {
      fontSize: ["14px", "16px", "18px"],
      fontWeight: 500,
      lineHeight: 1,
    },
    275: {
      fontSize: ["12px", "14px", "16px"],
      fontWeight: 500,
      lineHeight: 1,
    },
    250: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1,
    },
    200: {
      fontSize: ["11px", "11px", "12px"],
      fontWeight: 500,
      lineHeight: 1,
    },
  },
};
